export const MAINTENANCE_MACHINE_ID = 'maintenanceMachine'

export const WORKING_STATE = 'working'
export const MAINTENANCE_STATE = 'maintenance'

export const WORKING = 'WORKING'
export const MAINTENANCE = 'MAINTENANCE'
